import Vue from 'vue';
import Devices from './devices';
import Mfa from './mfa';
import Password from './password';

export default Vue.component('security-settings', {
  template: require('./template.html'),
  name: 'security-settings',
  components: {
    Devices,
    Mfa,
    Password,
  },
  props: ['social-user'],
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/security/index.js